<div class="filters">
  <a
    nz-dropdown
    nzTrigger="hover"
    [nzDropdownMenu]="typeMenu"
    class="t-small c-soft t-medium"
    i18n="@@allMessages"
  >
    All Messages
    <un-icon type="down" theme="outline"></un-icon>
    <nz-badge
      class="m-l-16"
      nzStandalone
      [nzCount]="(facade.unread$ | async) || 0"
      [nzShowZero]="false"
    ></nz-badge>
  </a>

  <un-icon
    type="funnel-plot"
    theme="outline"
    class="filter"
    nz-dropdown
    nzTrigger="click"
    [nzDropdownMenu]="filterMenu"
  ></un-icon>
</div>
<un-input
  size="small"
  prefixIcon="search"
  placeholder="Search by name"
  i18n-placeholder="@@searchByName"
  [formControl]="control"
></un-input>
<nz-dropdown-menu #typeMenu="nzDropdownMenu">
  <ul nz-menu>
    <li nz-menu-item i18n="@@application">Application</li>
    <li nz-menu-item i18n="@@visa">Visa</li>
  </ul>
</nz-dropdown-menu>
<nz-dropdown-menu #filterMenu="nzDropdownMenu">
  <ul nz-menu>
    <li nz-menu-item i18n="@@unrread">Unread</li>
    <li nz-menu-item i18n="@@closed">Closed</li>
  </ul>
</nz-dropdown-menu>
